import { render } from "./CookieConsent.vue?vue&type=template&id=a83ef43a&scoped=true"
import script from "./CookieConsent.vue?vue&type=script&lang=js"
export * from "./CookieConsent.vue?vue&type=script&lang=js"

import "./CookieConsent.vue?vue&type=style&index=0&id=a83ef43a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b7c0161fc3875e000d6ad7ba26fe3ce3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a83ef43a"]])

export default __exports__